export const GET_COUNT_COMMENT = "GET_COUNT_COMMENT";
export const SET_COUNT_COMMENT = "SET_COUNT_COMMENT";
export const ERROR_COUNT_COMMENT = "ERROR_COUNT_COMMENT";
export const GET_COUNT_REVIEW = "GET_COUNT_REVIEW";
export const SET_COUNT_REVIEW = "SET_COUNT_REVIEW";
export const ERROR_COUNT_REVIEW = "ERROR_COUNT_REVIEW";
export const GET_COUNT_FEEDBACK = "GET_COUNT_FEEDBACK";
export const SET_COUNT_FEEDBACK = "SET_COUNT_FEEDBACK";
export const ERROR_COUNT_FEEDBACK = "ERROR_COUNT_FEEDBACK";
